import React from 'react';
import Loadable from 'react-loadable'
import DefaultLayout from './containers/DefaultLayout';
import LoadingComp from './componentes/loading'

function Loading() {
  return <LoadingComp loading="true" />
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard'),
  loading: Loading,
});

const Ramais = Loadable({
  loader: () => import('./views/menu/ramais'),
  loading: Loading,
});

const TIChamados = Loadable({
  loader: () => import('./views/ti/chamados'),
  loading: Loading,
});

const servExecutados = Loadable({
  loader: () => import('./views/medico/servExecutados'),
  loading: Loading,
});

const repasses = Loadable({
  loader: () => import('./views/medico/repasses'),
  loading: Loading,
});

const repassesContador = Loadable({
  loader: () => import('./views/contador/repassesContador'),
  loading: Loading,
});

const pesqPac = Loadable({
  loader: () => import('./views/medico/pesqPac'),
  loading: Loading,
});

const exames = Loadable({
  loader: () => import('./views/medico/exames'),
  loading: Loading,
});

const ambulatorio = Loadable({
  loader: () => import('./views/medico/ambulatorio'),
  loading: Loading,
});

const contracheque = Loadable({
  loader: () => import('./views/funcionario/contracheque'),
  loading: Loading,
});

const questionario = Loadable({
  loader: () => import('./views/funcionario/questionario'),
  loading: Loading,
});

const questionarioResp = Loadable({
  loader: () => import('./views/funcionario/questionarioResp'),
  loading: Loading,
});

const dmed = Loadable({
  loader: () => import('./views/contador/dmed'),
  loading: Loading,
});

const nfse = Loadable({
  loader: () => import('./views/paciente/nfse'),
  loading: Loading,
});

const routes = [
  { path: '/', exact: true, name: 'Home', component: DefaultLayout }
  , { path: '/dashboard', name: 'Dashboard', component: Dashboard }
  , { path: '/ramais', name: 'Ramais', component: Ramais }
  , { path: '/contracheque', name: 'Contra Cheque', component: contracheque }
  , { path: '/questionario', name: 'Questionário', component: questionario }
  , { path: '/questionarioResp/:id', name: 'Responder Questionário', component: questionarioResp }
  , { path: '/ti', name: 'T.I.', component: TIChamados }
  , { path: '/servexec', name: 'Serviços Executados', component: servExecutados }
  , { path: '/repasses', name: 'Repasses', component: repasses }
  , { path: '/contador', name: 'Repasses', component: repassesContador }
  , { path: '/paciente/pesquisar', name: 'Pesquisar Paciente', component: pesqPac }
  , { path: '/paciente/:id/exames', name: 'Laudo dos Exames', component: exames }
  , { path: '/paciente/:id/ambulatorio', name: 'Ambulatório', component: ambulatorio }
  , { path: '/resultadoDeExames', name: 'Laudo dos Exames', component: exames }
  , { path: '/dmed', name: 'DMED', component: dmed }
  , { path: '/nfse', name: 'Nota Fiscal', component: nfse }
];

export default routes;
